// extracted by mini-css-extract-plugin
export default {"ItemsLink":"NavigationItems_ItemsLink__svJm8","NavigationItems":"NavigationItems_NavigationItems__KGsJq"};